import { Button, Form, Input, Radio, Select, Space } from "antd"
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import Base64Upload from "../../common/components/Base64Upload";
import DataSave, { DataSaveRef } from "../../common/components/DataSave";
import MainLayout from "../../common/components/MainLayout";
import TagInput from "../../common/components/TagInput";
import { ActionResult } from "../../common/hooks/useApi";
import { ConfiguracionProduccionForm } from "../../configuraciones-produccion/useConfiguracionesProduccionAPI";
import useEquiposAPI, { Equipo } from "../../equipos/useEquiposAPI";
import useUnidadesProduccionAPI, { UnidadProduccion } from "../../unidades-produccion/useUnidadesProduccionAPI";
import AreaInput, { AreaConfig, AreaType } from "../components/AreaInput";
import useConfiguracionesAnaliticaApi, { ConfiguracionAnalitica, ConfiguracionAnaliticaForm, ConfiguracionAnaliticaSave } from "../useConfiguracionesAnaliticaApi";

const areaInputConfigLights: AreaConfig[] = [
    {
        buttonText: 'Rojo',
        color: 'red',
        name: 'light_r',
        type:'rectangle',        
    },
    {
        buttonText: 'Amarillo',
        color: 'yellow',
        name: 'light_yellow',
        type:'rectangle',        
    },
    {
        buttonText: 'Verde',
        color: 'green',
        name: 'light_g',
        type:'rectangle',        
    },
    {
        buttonText: 'Flecha hacia la derecha',
        color: '#76ff03',
        name: 'light_right_g',
        type:'rectangle',        
    }
    ,
    {
        buttonText: 'Flecha hacia la izquierda',
        color: '#aeea00',
        name: 'light_left_g',
        type:'rectangle',        
    }
];


const areaInputConfig: { [key: string]: AreaConfig[] } = {
    'CRUCE_SEMAFORO': [
        ...areaInputConfigLights,
        ...[
            {
                buttonText: 'Fecha y hora',
                color: 'rgba(241, 227, 227, 0.1)',
                name: 'dt',
                type:'rectangle' as AreaType,
            },
            {
                name: 'a',
                buttonText: 'Foto A',
                color: 'limegreen',
                type:'polygon' as AreaType,                
            },
            {
                name: 'b',
                buttonText: 'Foto B',
                color: 'darkorange',
                multiple: true,
                type:'line' as AreaType,                
            }
            /*,
            {
                name: 'lpr',
                buttonText: 'Lectura de patente',
                color: 'blueviolet',
                multiple: true,
                type:'line' as AreaType
            },*/
        ]
    ],
    'INVASION_SENDA':[],
    'ESTADISTICA_CRUCE_SEMAFORO':[
        ...areaInputConfigLights,
        ...[
            {
                buttonText: 'Fecha y hora',
                color: 'white',
                name: 'dt',
                type:'rectangle' as AreaType,                
            },
            {
                name: 'a',
                buttonText: 'Zona A',
                color: 'limegreen',
                type:'polygon' as AreaType,                
            },
            {
                name: 'b',
                buttonText: 'Zona B',
                color: 'darkorange',
                multiple: true,
                type:'line' as AreaType,                
            },
        ]
    ]
};

export default () => {
    const dataSaveRef = useRef<DataSaveRef<ConfiguracionAnaliticaForm>>(null!);
    const { id } = useParams();
    const api = useConfiguracionesAnaliticaApi();
    const unidadesProduccionApi = useUnidadesProduccionAPI();
    const equiposApi = useEquiposAPI();
    const successRoute = "/neuralvision/configuraciones-analitica";
    const [imagenPreview, setImagenPreview] = useState<string>();
    const [imagen, setImagen] = useState<File>();
    const [item, setItem] = useState<ConfiguracionAnaliticaForm>({
        Areas: {}
    });
    const [unidadesProduccionResponse, setUnidadesProduccionResponse] = useState<ActionResult<UnidadProduccion[]>>();
    const [equiposResponse, setEquiposResponse] = useState<ActionResult<Equipo[]>>();

    useEffect(() => {
        unidadesProduccionApi
            .list({ $orderby: ["Nombre asc"], $top: 10000 })
            .then(setUnidadesProduccionResponse);
    }, []);

    useEffect(() => {
        const unidadProduccionId = item.UnidadProduccionId;

        if (!unidadProduccionId) {
            setEquiposResponse(undefined);
            return;
        }

        equiposApi
            .list({ $orderby: ["Nombre asc"], $filter: [`ConfiguracionProduccion/UnidadProduccionId eq ${unidadProduccionId}`], $top: 10000 })
            .then(setEquiposResponse);
    }, [item.UnidadProduccionId]);

    const loadPreview = () => {
        const input = document.createElement("input");
        input.type = 'file';
        input.onchange = () => {
            if (input.files?.length == 0) return;
            const Imagen = input.files![0];
            setImagenPreview(URL.createObjectURL(Imagen));
            setImagen(Imagen);
        }
        input.click();
    }

    const save = async (data:ConfiguracionAnaliticaSave)=>{
        


        return api.save(data);
    }

    return (<MainLayout>
        <DataSave<ConfiguracionAnalitica, ConfiguracionAnaliticaSave, ConfiguracionAnaliticaForm>
            list={(query) => api.list({ ...query, ...{ $expand: ['Equipo($expand=ConfiguracionProduccion)', 'Imagen'] } })}
            save={save}
            transformOnLoad={async (value) =>
            ({
                ...value,
                ...{
                    CriterioSemaforo: JSON.parse(value.CriterioSemaforo ?? "{}"),
                    EquipoId: value.Equipo?.Id,
                    Areas: JSON.parse(value.Areas),
                    ClasesPermitidas: JSON.parse(value.ClasesPermitidas)?.map((c: string) => ({ Nombre: c })),
                    UnidadProduccionId: value.Equipo?.ConfiguracionProduccion.UnidadProduccionId
                }
            })}
            transformOnSave={async () => {
                // Tomo todos los valores del form, ya que hago un put porque estoy subiendo un archivo
                const value = dataSaveRef.current.form.getFieldsValue(true);
                delete value.UnidadProduccionId;
                return ({ ...value, ...{ CriterioSemaforo: JSON.stringify(item.CriterioSemaforo), Areas: JSON.stringify(value.Areas), ClasesPermitidas: JSON.stringify((value.ClasesPermitidas ?? []).map((c: any) => c.Nombre)) }, ImagenUpload: imagen });
            }}
            id={id}
            successRoute={successRoute}
            onChange={(data) => {
                setItem(dataSaveRef.current.form.getFieldsValue(true));
            }}
            ref={dataSaveRef}
        >
            <Form.Item
                label={"Etiqueta"}
                name={"Etiqueta"}
            >
                <Input/>
            </Form.Item>

            <Form.Item
                label={"Unidad de producción"}
                name={"UnidadProduccionId"}
                required
                rules={[{
                    required: true,
                    message: "Campo requerido"
                }]}
            >
                <Select
                    loading={!unidadesProduccionResponse}>
                    {unidadesProduccionResponse?.data?.value.map(e =>
                        <Select.Option key={e.Id} value={e.Id}>{e.Nombre}</Select.Option>)}
                </Select>
            </Form.Item>

            <Form.Item
                label={"Equipo"}
                name={"EquipoId"}
                required
                rules={[{
                    required: true,
                    message: "Campo requerido"
                }]}
            >
                <Select
                    loading={(!equiposResponse && (item?.UnidadProduccionId ?? 0) > 0)}
                >
                    {equiposResponse?.data?.value.map(e =>
                        <Select.Option key={e.Id} value={e.Id}>{e.Nombre}</Select.Option>)}
                </Select>
            </Form.Item>
            <Form.Item
                label={"Tipo de analítica"}
                name={"Tipo"}
                required
                rules={[{
                    required: true,
                    message: "Campo requerido"
                }]}
            >
                <Select onChange={()=>{
                    dataSaveRef.current!.form.resetFields(['Areas'])
                }}>
                    <Select.Option value="CRUCE_SEMAFORO">Cruce indebido de semáforo</Select.Option>
                    {/*<Select.Option value="INVASION_SENDA">Invasión de senda peatonal</Select.Option>*/}
                    <Select.Option value="ESTADISTICA_CRUCE_SEMAFORO">Estadística de cruce de semáforo</Select.Option>

                </Select>
            </Form.Item>

            {item.Tipo && <Button style={{ marginBottom: 10 }} onClick={loadPreview}>Cargar vista previa</Button>}
            {/*item?.Tipo &&
                <Form.Item
                    name={"Imagen"}
                    required
                    rules={[{
                        required: true,
                        message: "Cargue una imagen como vista previa"
                    }]}
                >
                    <Base64Upload imgHeight={0} />
                </Form.Item>
            */}

            {(imagenPreview || item.Imagen) && item.Tipo &&
                <Form.Item
                    name={"Areas"}
                    label="Marcador de areas de interés">

                    <AreaInput
                        areas={[...areaInputConfig[item.Tipo]]} img={(imagenPreview || item.Imagen?.FullUrl)!} />
                </Form.Item>
            }

            <Form.Item
                label="Dirección de circulación"
                name="DireccionCirculacion"
                required
            >
                <Select>
                    <Select.Option value={'ARRIBA'}>Arriba</Select.Option>
                    <Select.Option value={'ABAJO'}>Abajo</Select.Option>
                    <Select.Option value={'IZQUIERDA'}>Izquierda</Select.Option>
                    <Select.Option value={'DERECHA'}>Derecha</Select.Option>
                </Select>
            </Form.Item>

            <Form.Item

                label="Criterio de luces"
            >
                <Space direction="vertical">
                    {areaInputConfigLights
                        .filter(a => item.Areas && item.Areas[a.name]?.length > 0)
                        .map((a) =>
                        <Space direction="horizontal" size={15}>
                            <strong>{a.buttonText}</strong>
                            <Form.Item
                                name={["CriterioSemaforo", a.name]}
                                style={{ marginBottom: 0 }}>
                                <Radio.Group >
                                    <Radio value={undefined}>Ignorar</Radio>
                                    <Radio value={1}>Encendido</Radio>
                                    <Radio value={0}>Apagado</Radio>
                                </Radio.Group>
                            </Form.Item>
                        </Space>)}
                </Space>
            </Form.Item>
            <Form.Item
                name={"ClasesPermitidas"}
                label="Tipos de objeto permitidos"
                rules={[{
                    required: true,
                    message: "Cargue al menos una etiqueta"
                }]}
            >
                <TagInput />
            </Form.Item>
            <Form.Item
                name="FormatoFechaHora"
                label="Formato de fecha y hora"
                rules={[{
                    required: item.Areas !== undefined && item.Areas['dt']?.length > 0,
                    message: "Campo requerido"
                }]}
            >
                <Input />
            </Form.Item>
            {/*['ESTADISTICA_CRUCE_SEMAFORO'].includes(item.Tipo ?? '') &&
            
            <Form.Item
                name="FormatoFechaNombreVideo"
                label="Formato de fecha (nombre de video)"
                help="Formato de fecha y hora correspondiente al nombre del video que se procese para obtener la estadística"
                required
                rules={[{
                    required: true,
                    message: "Campo requerido"
                }]}
            >
                <Input />
            </Form.Item>
            */}

        </DataSave>
    </MainLayout>);
}